import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import '../../../src/custom.css'
import Add from "../../assets/images/Add.svg";
import { DatePicker, Space } from 'antd';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import EditIcon from '@mui/icons-material/Edit';
import Loader from "../loader";
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import Layout from '../Layout';
import * as url from "../../api/uri_helper"
import Table, { TableProps } from "antd/lib/table";
import { fetchAllQrCodes, fetchQrCodesBySiteId } from '../../Redux/Api/fetch.api';
import { getQrCodeData } from '../../Redux/Actions/QR';
import { Tooltip } from 'antd';
import Switch from "react-switch";
import AddBoxIcon from '@mui/icons-material/AddBox';
import axios from "axios";
import EditNoteIcon from '@mui/icons-material/EditNote';
import Edit_light from "../../assets/images/Edit_light.svg";
import enUS from 'antd/es/date-picker/locale/en_US';
import { useTranslation } from "react-i18next";


const QREntriesIndex = () => {
    const { t } = useTranslation("dashboard");
    const [loading, setLoading] = useState(false);
    const [isManufacturing, setIsManufacturing] = useState(false);
    const [table, setTable] = useState([]);
    const dispatch = useDispatch();
    const [pageSize, setPageSize] = useState(50);
    const [productName, setProductName] = useState("");
    const [qrcodeId, setQRCodeId] = useState();
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: 50,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['50', '100']
        }
    });
    const [getRadioButton, setGetRadioButton] = useState({ show: "show", selected: "show", });
    const [productEditable, setProductEditable] = useState(false);
    const [pageData, setPageData] = useState({});
    const [total, setTotal] = useState()
    let history = useHistory();
    const comingsiteId = localStorage.getItem('SiteId');
    const [showAllData, setShowAllData] = useState(false);
    const [productEditableRow, setProductEditableRow] = useState(null);
    const [checkedListOfIds, setCheckedListOfIds] = useState([]);
    const [rangeStart, setRangeStart] = useState('');

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        getallQRCodes(options, showAllData);

    }, [])

    const getallQRCodes = (options, showAllData) => {
        const siteIdToSend = showAllData ? 0 : comingsiteId;
        setLoading(true)
        if (options && options.pagination == undefined) {
            options.pagination = pageData.pagination;
            options.pageSize = pageData.pageSize;
        }
        fetchQrCodesBySiteId(siteIdToSend)
            .then(response => {

                dispatch(getQrCodeData(response.data))
                setTable(response.data.data)
                setTotal(response.data.count)
                setOptions({
                    ...options,
                    pagination: {
                        pageSize: options.pagination.pageSize,
                        current: options.pagination.current,
                        total: response.data.count,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
                setLoading(false)
            })

            .catch((err) => {
                console.log("Err: ", err);
            });
        // setLoading(false)

    }

    const customLocale = {
        ...enUS,
        lang: {
            ...enUS.lang,
            timeSelect: 'Select Time' // <- This is the key you're looking for
        }
    };

    const handleChange = (pagination) => {
        setOptions(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current: pagination.current,
                pageSize: pagination.pageSize,
            }
        }));

        getallQRCodes({
            pagination: {
                current: pagination.current,
                pageSize: pagination.pageSize
            }
        }, true); // Pass `true` to force siteId = 0
    };

    const handleAddProduct = (record) => {
        setProductEditable(true)
        setProductEditableRow(record.qRcodeId);
        setQRCodeId(record.qRcodeId);
        setProductName(record.product_Name || "");
        setCheckedListOfIds("")
        uncheckcheckbox()
    };

    const updateProductName = async (qrcodeid) => {
        if (!productName || productName.trim().length === 0) {
            toast.error("Please Enter Product Name", {
                className: "toastSuccess",
            });
            return;
        }
        setLoading(true)
        const formData = new FormData();
        formData.append("ProductName", productName);
        formData.append("QRCodeId", qrcodeid);
        const response_ = await axios({
            method: 'post',
            url: url.SAVE_PRODUCTNAME,
            data: formData,
        }).then(response => {

            if (response.data.success == false) {
                toast.error("Product Name Already Exists", {
                    className: "toastSuccess",
                });
            }
            else {
                toast.success(response.data.message, {
                    className: "toastSuccess",
                });
                setProductName()
                getallQRCodes(options, showAllData);
                setProductEditable(false)
                setProductEditableRow()

            }
            setLoading(false)
        })
    }

    const cancelProductEdit = () => {
        setProductEditable(false)
        setProductName();
    }

    const getFullInstalDate = (date) => {
        // setLoading(true)
        if (date) {
            const dateAndTime = date.split('T');
            const time = dateAndTime[1].split(':')
            const newtime = time[0] + ':' + time[1]
            const times = time[0] > 12 ? time[0] % 12 : time[0]
            const newtime1 = times + ':' + time[1]
            if (time[0] && time[0] >= 12) {
                return dateAndTime[0].split('-').reverse().join('-') + ' , ' + newtime1 + " PM ";
            }
            else {
                return dateAndTime[0].split('-').reverse().join('-') + ' , ' + newtime + " AM ";
            }
        }
    };

    const handleCheck = (qRcodeId) => {

        var updatedList = [...checkedListOfIds];
        if (event.target.checked) {
            updatedList = [...checkedListOfIds, qRcodeId];
        } else {
            updatedList.splice(checkedListOfIds.indexOf(qRcodeId), 1);
        }
        setCheckedListOfIds([...updatedList]);

    };


    const columns = [

        {
            title: " ",
            dataIndex: "qRcodeId",
            hidden: false,
            render: (qRcodeId) => (<div className="checkgroup">
                {
                    <input type="checkbox" className="btn-checkbox" name="checkname"

                        onChange={() => { handleCheck(qRcodeId) }}
                        key={qRcodeId}
                    ></input>
                }
            </div>)
        },

        //{
        //    title: "Sr. No.",
        //    dataIndex: "",
        //    render: (text, record, index) => {
        //        const current = options.pagination.current || 1;
        //        const pageSize = options.pagination.pageSize || 50;
        //        return (current - 1) * pageSize + index + 1;
        //    },
        //},

        {
            title: t("QRCode"),
            dataIndex: "qRcodeId",
            className: "qrcode_mapping",
        },
        {
            title: t("Site"),
            dataIndex: "qRcodeId",
            className: "Locations",
            key: 'index',
            render: (text, record, index) => (
                <>
                    {record.locationName}
                </>
            )
        },

        {
            title: t("ManDate"),
            className: "update_qrcode",
            dataIndex: "manufacturing_Date",
            //key: 'installation_Date',

            render: ((date) => getFullInstalDate(date))

        },

        {
            title: t("InstDate"),
            className: "update_qrcode",
            dataIndex: "installation_Date",
            //key: 'installation_Date',

            render: ((date) => getFullInstalDate(date))

        },

        {
            title: t("ProductName"),
            dataIndex: "product_Name",
            render: (product_Name, record) =>
                productEditable && productEditableRow === record.qRcodeId ? (
                    <div className="d-flex gap-2" style={{ whiteSpace: "nowrap", justifyContent: "left" }}>
                        <input
                            name="productName"
                            className="form-control edit-product-name"
                            style={{ maxWidth: "200px" }}
                            type="text"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                        />
                        <button
                            className="group-btn w-auto px-2 text-white btn-primary"
                            onClick={() => updateProductName(record.qRcodeId)}
                        >
                            {record.product_Name ? t("Update") : t("Add")}
                        </button>
                        <button
                            className="group-btn w-auto px-2 text-white btn-secondary"
                            onClick={cancelProductEdit}
                        >
                            {t("Cancel")}
                        </button>
                    </div>
                ) : (
                    <Tooltip
                        placement="topLeft"
                        className="media-tooltip product-name"
                        title={product_Name}
                    >
                        {product_Name ? product_Name : " "}
                    </Tooltip>
                )
        },


        {
            title: t("ActionOnProduct"),
            dataIndex: "action",
            key: "action",
            render: (_, record) => (
                <Tooltip
                    placement="topLeft"
                    title={record.product_Name ? t("EditProductName") : t("AddProductName")}
                >
                    <button
                        onClick={() => handleAddProduct(record)}
                        style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                        }}
                    >
                        {record.product_Name ? (
                            <button className="table-btn" >
                                <img
                                    src={Edit_light}
                                    alt="Edit"
                                    style={{ width: 22, height: 22 }}
                                />
                            </button>
                        ) : (
                            <AddBoxIcon style={{ fontSize: 28, color: "#b97a57" }} />
                        )}
                    </button>
                </Tooltip>
            )
        }


    ]

    const handleSwitchChange = (checked) => {
        setShowAllData(checked);
        getallQRCodes(options, checked);
    };

    const uncheckcheckbox = () => {
        var items = document.getElementsByName('checkname');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
    }

    const handleDateUpdate = async () => {
        setLoading(true)
        if (checkedListOfIds.length >= 1) {
            const data = [];
            checkedListOfIds.map(x => data.push({
                QRcodeId: x,
                Date: rangeStart,
                IsManufacturing: getRadioButton.show == "hide" ? false : true
            }))
            const response = await axios.put(url.UPDATE_QRCODEDATES,
                {
                    "InstDateQrs": data
                }).then(response => {

                    // dispatch(updateInstLocationData(response.data))
                    setRangeStart();
                    if (!response.data.success) // False 
                    {

                        toast.error(response.data.message, {
                            className: "toastSuccess",
                        });
                    }
                    else {
                        toast.success(response.data.message, {
                            className: "toastSuccess",
                        })
                    }
                    setLoading(false)
                })
            getallQRCodes(options, showAllData)
            setCheckedListOfIds('')
            uncheckcheckbox();
            setRangeStart("")

        }
    }

    const radioButtonValueChange = (e) => {
        if (e.target.value === "show") {
            setIsManufacturing(true)
            setGetRadioButton({
                show: "show",
                selected: e.target.value,
            });
        } else {
            setGetRadioButton({
                show: "hide",
                selected: e.target.value,
            });
        }
    };

    const onChange = (date) => {
        setRangeStart(date); // `date` is already a moment object from DatePicker
    };




    return (
        <Layout title="Device Type"><Toaster />
            <div className="position-relative qr-entries">
                <div className="card-box-header d-inline-flex w-100 align-items-center gap-4 m-0 flex-wrap">
                    <h4 className="m-0">{t("QREntries")}</h4>
                    <div className="d-flex align-items-center">
                        <label className="filter-col me-3 mb-0">{t("ShowAllLabel")}</label>
                        <Switch
                            onChange={handleSwitchChange}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checked={showAllData}
                            onColor="#bb9977"
                            handleDiameter={20}
                            height={16}
                            width={35}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            onHandleColor="#b97a57"

                        />
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center gap-2">
                            {" "}
                            <input
                                type="radio"
                                value="show"
                                name="content"
                                id="show"
                                // className="mr-2"
                                onClick={radioButtonValueChange}
                                checked={getRadioButton.selected === "show"}
                            />
                            <label className="m-0" for="show">{t("BulkManDateUpdate")}</label>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            {" "}
                            <input
                                // className="mr-2"
                                type="radio"
                                value="hide"
                                name="content"
                                id="hide"
                                onClick={radioButtonValueChange}
                                checked={getRadioButton.selected === "hide"}
                            />
                            <label className="m-0" for="show">{t("BulkInstDateUpdate")}</label>{" "}
                        </div>


                    </div>

                    <div className="ms-auto d-flex align-items-center gap-3">
                        {checkedListOfIds.length >= 1 ? (
                            <div className="d-flex align-items-center flex-wrap gap-3 justify-content-end update_location" >
                                <span className="location-span">
                                    {getRadioButton.selected === "hide" ? t("SelectInstDateLabel") : t("SelectManDateLabel")}
                                </span>
                                <div style={{ display: 'flex', flexDirection: '' }}>
                                    <DatePicker
                                        format="MM/DD/YYYY HH:mm:ss"
                                        showTime
                                        placeholder={t("SelectDatePlaceholder")}
                                        onChange={onChange}
                                        value={rangeStart}
                                        locale={customLocale}
                                    />
                                </div>

                                {
                                    checkedListOfIds.length >= 1 ?
                                        <button className="btn btn-primary"
                                            onClick={() => handleDateUpdate()}
                                            disabled={(rangeStart === '' || rangeStart === null)}
                                        >{t("UpdateTitle")}</button>
                                        : ""
                                }
                            </div>

                        ) : ""}
                     {/*   <Link className="btn btn-primary d-flex align-items-center" to="/QREntries/Add"><img src={Add}></img>Add QRCode</Link>*/}
                    </div>
                </div>
            </div>
            <div className="Viewer-table table-new pagination-sticky device-type status position-relative">
                {loading ? <Loader /> : ''}
                <Table
                    //className='table-responsive Viewer-table mb-4'
                    className='table-responsive antd--detail-table1 Viewer-table'
                    columns={columns}
                    dataSource={table}
                    pagination={
                        total > 50 ? options.pagination : false
                    }
                    // pagination={options.pagination.total > 10 && totalIndex > 9 ? options.pagination : false}
                    onChange={handleChange}
                    //  paginationTotalRows={total}
                    scroll={{ x: "750px" }}

                />
            </div>
        </Layout>

    )



}
export default connect()(QREntriesIndex);
